export default __webpack_public_path__ + "static/media/call.a82f6e05.svg";